export enum EligibilityInclusionOption {
  currently_eligible = 'currently_eligible',
  all_time_eligible = 'all_time_eligible',
}
